
import React, { useState } from 'react';

function AgencyForm() {
  const [formData, setFormData] = useState({
    agencyName: '',
    contactEmail: '',
    status: 'Active'
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Submitted:", formData);
  };

  return (
    <form onSubmit={handleSubmit} className="bg-white p-6 rounded shadow-md w-full max-w-xl">
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700">Agency Name</label>
        <input name="agencyName" type="text" value={formData.agencyName} onChange={handleChange}
          className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
      </div>
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700">Contact Email</label>
        <input name="contactEmail" type="email" value={formData.contactEmail} onChange={handleChange}
          className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
      </div>
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700">Status</label>
        <select name="status" value={formData.status} onChange={handleChange}
          className="mt-1 block w-full border-gray-300 rounded-md shadow-sm">
          <option value="Active">Active</option>
          <option value="Inactive">Inactive</option>
        </select>
      </div>
      <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded shadow hover:bg-blue-700">
        Save Agency
      </button>
    </form>
  );
}

export default AgencyForm;
